var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.5C9.9087 20.5 8.38258 19.8679 7.25736 18.7426C6.13214 17.6174 5.5 16.0913 5.5 14.5",
    stroke: "#161616",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.5C9.5 7.709 5.5 11.5 5.5 11.5C5.5 11.5 1.5 7.709 1.5 5.5C1.5 4.43913 1.92143 3.42172 2.67157 2.67157C3.42172 1.92143 4.43913 1.5 5.5 1.5C6.56087 1.5 7.57828 1.92143 8.32843 2.67157C9.07857 3.42172 9.5 4.43913 9.5 5.5V5.5Z",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.5C23.5 15.814 17.5 22 17.5 22C17.5 22 11.5 15.814 11.5 12.5C11.5 10.9087 12.1321 9.38258 13.2574 8.25736C14.3826 7.13214 15.9087 6.5 17.5 6.5C19.0913 6.5 20.6174 7.13214 21.7426 8.25736C22.8679 9.38258 23.5 10.9087 23.5 12.5Z",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5C6.05228 6.5 6.5 6.05228 6.5 5.5C6.5 4.94772 6.05228 4.5 5.5 4.5C4.94772 4.5 4.5 4.94772 4.5 5.5C4.5 6.05228 4.94772 6.5 5.5 6.5Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5C18.6046 14.5 19.5 13.6046 19.5 12.5C19.5 11.3954 18.6046 10.5 17.5 10.5C16.3954 10.5 15.5 11.3954 15.5 12.5C15.5 13.6046 16.3954 14.5 17.5 14.5Z",
    stroke: "#212121",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPins);
export default __webpack_public_path__ + "static/media/MapPins.8d4bb4b8.svg";
export { ForwardRef as ReactComponent };